module.exports = __webpack_public_path__ + "static/media/index.30352b15.less";